import { render } from "./BookPage.vue?vue&type=template&id=575f7dc0&scoped=true"
import script from "./BookPage.vue?vue&type=script&lang=js"
export * from "./BookPage.vue?vue&type=script&lang=js"

import "./BookPage.vue?vue&type=style&index=0&id=575f7dc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575f7dc0"]])

export default __exports__